import { Row } from "react-bootstrap";
import logo from './images/hd_transparent_logo.png';

export function Header() {
    return (
        <header id='header'>
            <div className='intro bg-matrix'>
                <div className='intro-content fade-in'>
                    <div className="logo-hero-container">
                        <img 
                            src={logo}
                            alt="Dance at Beat Logo"
                            className="hero-logo"
                        />
                        <div className="logo-glow-ring"></div>
                        <div className="logo-particles">
                            <div className="particle particle-1"></div>
                            <div className="particle particle-2"></div>
                            <div className="particle particle-3"></div>
                            <div className="particle particle-4"></div>
                            <div className="particle particle-5"></div>
                            <div className="particle particle-6"></div>
                        </div>
                    </div>
                    
                    <div className="cta-buttons">
                        <a href="#lessen" className="btn-primary-modern">
                            <i className="fas fa-play me-2"></i>
                            Bekijk Lessen
                        </a>
                        <a href="#contact" className="btn-secondary-modern">
                            <i className="fas fa-envelope me-2"></i>
                            Contact
                        </a>
                    </div>
                </div>
                
                <div className="mouse_scroll">
                    <div className="mouse">
                        <div className="wheel"></div>
                    </div>
                    <div className="m_scroll_arrows"></div>
                    <div className="m_scroll_arrows"></div>
                    <div className="m_scroll_arrows"></div>
                </div>
            </div>
        </header>
    )
}